import { ICustomerLastUnitsRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisCustomerLastUnitsRepository from './implementations/VectisCustomerLastUnitsRepository';

let instance: ICustomerLastUnitsRepository | null = null;

export default function makeCustomerLastUnitsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisCustomerLastUnitsRepository(httpProvider);
  }

  return instance;
}
